<div class="cmx-alert-bar" [ngClass]="alertClass" [dir]="rtl ? 'rtl': 'ltr'">
    <p class="cmx-alert-bar__message">
        <ng-content></ng-content>
        <ng-content select="a"></ng-content>
    </p>
    <button class="cmx-alert-bar__close" (click)="close()">
        <span class="cmx-icon-close" aria-hidden="true"></span><span class="sr-only">Dismiss Alert</span>
    </button>
</div>